import ColorThief from 'colorthief';

export function getLuminance(hex: string): number {
  try {
    const rgb = hexToRgb(hex);
    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;

    return luminance;
  } catch (error) {
    console.error(`Error calculating luminance for color ${hex}:`, error);
    return 0;
  }
}

export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  if (typeof hex !== 'string') {
    throw new TypeError(`Expected a string, but received ${typeof hex}`);
  }

  const pureHex = hex.trim().replace(/^#/, '');

  const isValidHex = /^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

  if (!isValidHex.test(pureHex)) {
    throw new Error(`Invalid HEX code: ${hex}`);
  }

  const fullHex =
    pureHex.length === 3
      ? pureHex
          .split('')
          .map((char) => char + char)
          .join('')
      : pureHex;

  const r = parseInt(fullHex.substring(0, 2), 16);
  const g = parseInt(fullHex.substring(2, 4), 16);
  const b = parseInt(fullHex.substring(4, 6), 16);

  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    throw new Error(`Failed to convert HEX to RGB: ${hex}`);
  }

  return { r, g, b };
}

export const getAverageColorByImage = (image: HTMLImageElement): string => {
  const colorThief = new ColorThief();

  try {
    const colors = colorThief.getColor(image);

    return `rgb(${colors[0]}, ${colors[1]}, ${colors[2]})`;
  } catch (error) {
    console.error(error);
    return 'rgba(0, 0, 0, 0.8)';
  }
};
